import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./integrations/sentry/client.ts";

initSentry();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found!");
}

// Intercept any hash fragments containing access_token on initial load
// This helps with direct password reset links
if (
  window.location.hash &&
  window.location.hash.includes("access_token=") &&
  window.location.hash.includes("type=recovery") &&
  window.location.pathname !== "/auth/set-password"
) {
  console.log(
    "Initial load with recovery token detected, redirecting to set-password"
  );
  window.location.href = "/auth/set-password" + window.location.hash;
}

const root = createRoot(rootElement);


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
